import React from "react"

const InputRadio = ({ name, label, options, onChange, value }) => {
  return (
    <fieldset>
      <label className="text-gray-700 capitalize" htmlFor="">
        {label}
      </label>
      {options?.map((option, index) => (
        <div key={index} className="mt-2">
          <input
            id={option.value}
            type="radio"
            name={name}
            value={option.value}
            checked={option.value === value}
            onChange={(e) => onChange(option.value)}
          />
          <label htmlFor={option.value} className="ml-2">
            {option.label}
          </label>
        </div>
      ))}
    </fieldset>
  )
}

export default InputRadio
